var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 54,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 0h119v54H0V2a2 2 0 0 1 2-2z",
    fill: "#F4F7FA"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "AvenirNext-DemiBold, Avenir Next",
    fontSize: 12,
    fontWeight: 500,
    letterSpacing: 2,
    fill: "#555A77"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 40,
    y: 28
  }, "SECURITY "), /*#__PURE__*/React.createElement("tspan", {
    x: 40,
    y: 40
  }, "VERIFIED")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 12)"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#555B76",
    strokeWidth: 2,
    cx: 11.5,
    cy: 18.5,
    r: 10.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 8V5.6C6 2.507 8.462 0 11.5 0S17 2.507 17 5.6V8",
    stroke: "#555A77",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-180 7 11.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#555A77",
    cx: 2.5,
    cy: 5.6,
    rx: 2.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 0c.46 0 .833.373.833.833V4.8H1.667V.833C1.667.373 2.04 0 2.5 0z",
    fill: "#555B76"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "assets/20260723123210/media/verified.40af32e1cb981cca53538c94a481a12a.svg";
export { ForwardRef as ReactComponent };